import api from '@/store/api';
import { athena } from '@/store/api/instances';

import type { IntegrationViewICollectionIActionDataResponse } from '@/types/generated/athena';

export const integrationsApi = api.injectEndpoints({
  endpoints: (build) => ({
    getIntegrations: build.query<IntegrationViewICollectionIActionDataResponse, void>({
      query: () => athena({ url: 'v2/resources/integrations', method: 'GET' }),
    }),
  }),
});

export const { useGetIntegrationsQuery } = integrationsApi;
